import cn from "classnames";
import { useTranslation } from "react-i18next";

import { EEmailEventType } from "../../emailNotifications.types";
import { EVENT_TYPE_LABELS, EVENT_TYPE_VALUES } from "../../constants";

import styles from "./EventTypeFilter.module.scss";

interface EventTypeFilterProps {
  value: EEmailEventType | "all";
  onChange: (value: EEmailEventType | "all") => void;
}

const EventTypeFilter = ({ value, onChange }: EventTypeFilterProps) => {
  const { t } = useTranslation();

  const options: Array<{ key: EEmailEventType | "all"; label: string }> = [
    { key: "all", label: t("All") },
    ...EVENT_TYPE_VALUES.map((type) => ({
      key: type,
      label: t(EVENT_TYPE_LABELS[type])
    }))
  ];

  return (
    <div className={styles.filter}>
      {options.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={cn(styles.filter__pill, {
            [styles["filter__pill--active"]]: value === key
          })}
          onClick={() => onChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default EventTypeFilter;
